import React from "react";
import {
  Box,
  Flex,
  Icon,
  Heading,
  IconButton,
  Text,
  Button,
  Spinner,
} from "@chakra-ui/core";
import { FormErrorMessageListener } from "components/listeners/FormErrorMessageListener";
import { TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { NewsletterSignupForm } from "components/forms/NewsletterSignupForm";
import useFirebaseSession from "hooks/useFirebaseSession";

const CustomTextField = withStyles({
  root: {
    background: "white",
    borderRadius: "4px 0px 0px 4px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderRadius: `4px 0 0 4px`,
      },
    },
  },
})(TextField);

export function NewsletterPopupForm() {
  const { userIsLoggedIn } = useFirebaseSession();

  return (
    !userIsLoggedIn && (
      <NewsletterSignupForm>
        {({
          values,
          setFieldValue,
          handleSubmit,
          isSubmitting,
          errors,
          submitCount,
          someFieldHasError,
          getErrorMessage,
          formShown,
          setFormShown,
          signedUpSuccessfully,
        }) => (
          <Flex
            zIndex={300}
            position="sticky"
            pointerEvents="none"
            w="100%"
            bottom={0}
            justifyContent="flex-end"
          >
            <FormErrorMessageListener
              errors={errors}
              submitCount={submitCount}
              someFieldHasError={someFieldHasError}
              getErrorMessage={getErrorMessage}
            />
            <Box
              pointerEvents="all"
              display={formShown ? "block" : "none"}
              bg="#45C2B8"
              h="auto"
              w={["calc(100% - 16px)", "460px", "560px"]}
              p={4}
              borderRadius={4}
              boxShadow="md"
              position="absolute"
              bottom="16px"
              marginRight="8px"
              marginLeft="8px"
            >
              <Flex mb={1}>
                <Flex w="100%" alignItems="center">
                  <Icon name="email" fontSize="xl" color="black" />
                  <Heading fontSize="xl" ml={2} color="black">
                    We also write emails.
                  </Heading>
                </Flex>
                <IconButton
                  onClick={() => setFormShown(false)}
                  icon="close"
                  bg="transparent"
                  aria-label="close"
                />
              </Flex>
              <Text fontSize="md" fontWeight="medium">
                The best weekly roundup of global news on South Asia(ns). Like
                your other weekly briefings, but Browner.
              </Text>
              <Flex w="100%" mt={4}>
                <NewsletterPopupFormFields
                  email={values.email}
                  emailHasError={submitCount > 0 && Boolean(errors?.email)}
                  onChangeEmail={(email) => setFieldValue("email", email)}
                  isSubmitting={isSubmitting}
                  onClickSubmit={handleSubmit}
                  submittedSuccessfully={signedUpSuccessfully}
                />
              </Flex>
            </Box>
          </Flex>
        )}
      </NewsletterSignupForm>
    )
  );
}

type NewsletterPopupFormFieldsProps = {
  email: string;
  emailHasError: boolean;
  onChangeEmail: (email: string) => void;
  isSubmitting: boolean;
  submittedSuccessfully: boolean;
  onClickSubmit: () => void;
};

export function NewsletterPopupFormFields(
  props: NewsletterPopupFormFieldsProps
) {
  const {
    email,
    onChangeEmail,
    emailHasError,
    isSubmitting,
    submittedSuccessfully,
    onClickSubmit,
  } = props;

  return !submittedSuccessfully ? (
    <>
      <CustomTextField
        placeholder="Email"
        value={email}
        onChange={(e) => onChangeEmail(e.target.value)}
        error={emailHasError}
        variant="outlined"
        size="small"
        fullWidth
      />
      <Button
        _hover={{ backgroundColor: "#374151" }}
        _active={{ backgroundColor: "#374151" }}
        roundedLeft={0}
        onClick={onClickSubmit}
        bg="black"
        aria-label="submit"
      >
        {isSubmitting ? (
          <Spinner size="sm" />
        ) : (
          <Icon color="white" name="arrow-forward" />
        )}
      </Button>
    </>
  ) : (
    <Heading size="xs">Thanks for subscribing!</Heading>
  );
}
